/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ajuna_chain_about = () => `The Ajuna platform provides a simplified way for Unreal and Unity developers to build an incentive layer into their games using tokenized virtual goods. The partnership with Integritee will allow Ajuna to run entire gaming engines in trusted execution environments to create fast, secure, and scalable decentralized gaming ecosystems.`
